import Dexie, { Table } from 'dexie';

export interface ILogItem {
  id?: number;
  timestamp: string;
  message: string;
  level: number;
  additional: any[] | undefined;
}

const RETENTION_HOURS = 48;
const CLEANUP_INTERVAL_MS = 6 * 60 * 60 * 1000;

export class LogDB extends Dexie {
  logs!: Table<ILogItem, number>;

  constructor() {
    super('log');

    this.version(1).stores({
      log: 'timestamp',
    });

    // v2: PK je bio sam timestamp — dva zapisa u ISTOJ milisekundi (sasvim uobičajeno,
    // npr. više logger poziva u istom tick-u) su na drugom pravila ConstraintError i
    // tiho ga gubila. Dexie ne ume da promeni PK postojeće tabele, pa se stara tabela
    // briše i pravi nova sa auto-increment ključem (gubi se najviše 48h starih logova).
    this.version(2).stores({
      log: null,
      logs: '++id, timestamp',
    });

    this.purgeOldEntries();
    // Kiosk/KD uređaji rade nedeljama bez reload-a — čišćenje samo pri konstrukciji
    // bi na njima puštalo bazu da raste neograničeno.
    setInterval(() => this.purgeOldEntries(), CLEANUP_INTERVAL_MS);
  }

  purgeOldEntries() {
    const cutoff = new Date();
    cutoff.setHours(cutoff.getHours() - RETENTION_HOURS);

    this.logs.where('timestamp').below(cutoff.toISOString()).delete()
      .catch(() => { /* baza trenutno nedostupna — pokušaće opet za 6h */ });
  }
}

export const logDB = new LogDB();
